export default "__VITE_ASSET__SAbqxoi6__"